// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The list is taller than a laptop viewport. Cap the dialog and scroll the
   categories, so the title, the zoom strip and Got it always stay on screen */
.modal.shortcuts .dialog {
    width: 820px;
    top: 50%;
    max-height: 90vh;

    display: flex;
    flex-direction: column;
}

.modal.shortcuts .dialog .titlebar {
    background-color: var(--ui-modal-header-bg);
    flex: 0 0 auto;
}

.modal.shortcuts .dialog .body {
    padding-top: 6px;
    /* a flex child only scrolls if it's allowed to shrink past its content */
    min-height: 0;
}

.modal.shortcuts .dialog .section {
    border-top: 1px solid var(--black-20);
    padding-top: 10px;
}

.modal.shortcuts .dialog .section:first-of-type {
    border-top: none;
    padding-top: 0;
}

.modal.shortcuts .dialog .section-title {
    color: var(--black-85);
    font-weight: bold;
    font-size: 14px;
    margin: 4px 0 8px 0;
}

.modal.shortcuts .dialog .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 6px 0;
}

.modal.shortcuts .dialog .row .action {
    color: var(--black-65);
}

.modal.shortcuts .dialog .row .keys {
    display: flex;
    gap: 6px;
}

.modal.shortcuts .dialog .row .or {
    color: var(--black-45);
    padding: 0 4px;
}

.keycap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    min-width: 22px;
    padding: 0 8px;
    border-radius: 4px;
    background-color: var(--black-10);
    border: 1px solid var(--black-25);
    color: var(--black-85);
    font-weight: 600;
}

.modal.shortcuts .dialog .footnote {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--black-20);
    color: var(--black-45);
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
}

.modal.shortcuts .search {
    position: relative;
    margin-bottom: 8px;
}

.modal.shortcuts .search .icon {
    position: absolute;
    top: 6px;
    left: 10px;
    font-size: 20px;
    color: var(--black-45);
    user-select: none;
}

.modal.shortcuts .searchbox {
    margin-top: 2px;
    font-size: 14px;
    width: 100%;
    height: 30px;
    padding: 5px;
    padding-left: 34px;
    color: var(--black-65);
    background-color: var(--black-10);
    border: solid var(--black-15) 1px;
    border-radius: 4px;
    outline: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.modal.shortcuts .searchbox::placeholder { color: var(--black-35); }

.modal.shortcuts .sections {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px 24px;

    /* the only part that scrolls; 0 lets it shrink inside the capped dialog */
    min-height: 0;
    overflow-y: auto;
}
 
.modal.shortcuts .no-results {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--black-65);
  padding: 40px 0;
}

@media (min-width: 700px) {
  .modal.shortcuts .dialog { width: 820px; }
  .modal.shortcuts .sections { grid-template-columns: 1fr 1fr; }
}

/* no constant size/no-results styles (rolled back) */

/* Everything but the scrolling category grid keeps its natural height */
.modal.shortcuts .dialog .body > .zoom,
.modal.shortcuts .dialog .body > .actions,
.modal.shortcuts .dialog .body > .footnote {
    flex: 0 0 auto;
}

/* Zoom strip above the categories */
.modal.shortcuts .dialog .zoom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--black-20);
}

.modal.shortcuts .dialog .zoom .action {
    color: var(--black-85);
    font-weight: bold;
    font-size: 14px;
}

.modal.shortcuts .dialog .zoom .items {
    display: flex;
    gap: 20px;
}

.modal.shortcuts .dialog .zoom .item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.modal.shortcuts .dialog .zoom .item .keys {
    display: flex;
    gap: 6px;
}

.modal.shortcuts .dialog .zoom .item .label {
    color: var(--black-65);
}
`, "",{"version":3,"sources":["webpack://./src/shortcuts.css"],"names":[],"mappings":"AAAA;8EAC8E;AAC9E;IACI,YAAY;IACZ,QAAQ;IACR,gBAAgB;;IAEhB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yEAAyE;IACzE,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,2CAA2C,sBAAsB,EAAE;;AAEnE;IACI,aAAa;IACb,0BAA0B;IAC1B,cAAc;;IAEd,0EAA0E;IAC1E,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B,YAAY,EAAE;EACzC,6BAA6B,8BAA8B,EAAE;AAC/D;;AAEA,qDAAqD;;AAErD,wEAAwE;AACxE;;;IAGI,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET,mBAAmB;IACnB,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* The list is taller than a laptop viewport. Cap the dialog and scroll the\n   categories, so the title, the zoom strip and Got it always stay on screen */\n.modal.shortcuts .dialog {\n    width: 820px;\n    top: 50%;\n    max-height: 90vh;\n\n    display: flex;\n    flex-direction: column;\n}\n\n.modal.shortcuts .dialog .titlebar {\n    background-color: var(--ui-modal-header-bg);\n    flex: 0 0 auto;\n}\n\n.modal.shortcuts .dialog .body {\n    padding-top: 6px;\n    /* a flex child only scrolls if it's allowed to shrink past its content */\n    min-height: 0;\n}\n\n.modal.shortcuts .dialog .section {\n    border-top: 1px solid var(--black-20);\n    padding-top: 10px;\n}\n\n.modal.shortcuts .dialog .section:first-of-type {\n    border-top: none;\n    padding-top: 0;\n}\n\n.modal.shortcuts .dialog .section-title {\n    color: var(--black-85);\n    font-weight: bold;\n    font-size: 14px;\n    margin: 4px 0 8px 0;\n}\n\n.modal.shortcuts .dialog .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 0;\n}\n\n.modal.shortcuts .dialog .row .action {\n    color: var(--black-65);\n}\n\n.modal.shortcuts .dialog .row .keys {\n    display: flex;\n    gap: 6px;\n}\n\n.modal.shortcuts .dialog .row .or {\n    color: var(--black-45);\n    padding: 0 4px;\n}\n\n.keycap {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 22px;\n    min-width: 22px;\n    padding: 0 8px;\n    border-radius: 4px;\n    background-color: var(--black-10);\n    border: 1px solid var(--black-25);\n    color: var(--black-85);\n    font-weight: 600;\n}\n\n.modal.shortcuts .dialog .footnote {\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid var(--black-20);\n    color: var(--black-45);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    justify-content: center;\n}\n\n.modal.shortcuts .search {\n    position: relative;\n    margin-bottom: 8px;\n}\n\n.modal.shortcuts .search .icon {\n    position: absolute;\n    top: 6px;\n    left: 10px;\n    font-size: 20px;\n    color: var(--black-45);\n    user-select: none;\n}\n\n.modal.shortcuts .searchbox {\n    margin-top: 2px;\n    font-size: 14px;\n    width: 100%;\n    height: 30px;\n    padding: 5px;\n    padding-left: 34px;\n    color: var(--black-65);\n    background-color: var(--black-10);\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.modal.shortcuts .searchbox::placeholder { color: var(--black-35); }\n\n.modal.shortcuts .sections {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px 24px;\n\n    /* the only part that scrolls; 0 lets it shrink inside the capped dialog */\n    min-height: 0;\n    overflow-y: auto;\n}\n \n.modal.shortcuts .no-results {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--black-65);\n  padding: 40px 0;\n}\n\n@media (min-width: 700px) {\n  .modal.shortcuts .dialog { width: 820px; }\n  .modal.shortcuts .sections { grid-template-columns: 1fr 1fr; }\n}\n\n/* no constant size/no-results styles (rolled back) */\n\n/* Everything but the scrolling category grid keeps its natural height */\n.modal.shortcuts .dialog .body > .zoom,\n.modal.shortcuts .dialog .body > .actions,\n.modal.shortcuts .dialog .body > .footnote {\n    flex: 0 0 auto;\n}\n\n/* Zoom strip above the categories */\n.modal.shortcuts .dialog .zoom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n\n    margin-bottom: 12px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid var(--black-20);\n}\n\n.modal.shortcuts .dialog .zoom .action {\n    color: var(--black-85);\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.modal.shortcuts .dialog .zoom .items {\n    display: flex;\n    gap: 20px;\n}\n\n.modal.shortcuts .dialog .zoom .item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.modal.shortcuts .dialog .zoom .item .keys {\n    display: flex;\n    gap: 6px;\n}\n\n.modal.shortcuts .dialog .zoom .item .label {\n    color: var(--black-65);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
